"use client";

// @ts-strict-ignore
import styled from "styled-components";

export const CustomizableSpan = styled.span`
  font-weight: ${(props) => (props.bold ? 600 : 400)};
  font-style: ${(props) => (props.italic ? "italic" : "normal")};
  text-decoration: ${(props) => (props.underline ? "underline" : "none")};
`;
